import { Mark } from './Primitives';

/* Compatibility shim, restyled to the new brand. */
export default function SectionHead({ eyebrow, badge, title, subtitle, align = 'left' }) {
  const label = eyebrow || badge;
  const centered = align === 'center';
  return (
    <div className={centered ? 'text-center' : ''}>
      {label && (
        <div className={centered ? 'flex justify-center' : ''}>
          <Mark>{label}</Mark>
        </div>
      )}
      <h1 className={`mt-3 font-serif text-4xl leading-tight md:text-5xl ${centered ? 'mx-auto' : ''} max-w-[24ch]`}>
        {title}
      </h1>
      {subtitle && (
        <p className={`mt-4 max-w-measure-wide leading-relaxed text-slate ${centered ? 'mx-auto' : ''}`}>{subtitle}</p>
      )}
    </div>
  );
}
